import React from "react";
import {
  Box,
  Icon,
  IconButton,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { FiX } from "react-icons/fi";
import { useLocation } from "react-router-dom";

const CHATBOT_URL = "https://oib.liara.run";

const MotionBox = motion(Box);
const MotionIconButton = motion(IconButton);

export const PublicChatbotWidget = () => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  const buttonBg = useColorModeValue("brand.500", "brand.400");
  const buttonHoverBg = useColorModeValue("brand.400", "brand.300");
  const panelBg = useColorModeValue("white", "dark.50");
  const panelBorder = useColorModeValue("blackAlpha.100", "whiteAlpha.200");
  const shadowColor = useColorModeValue(
    "0 24px 60px rgba(15, 23, 42, 0.18)",
    "0 24px 60px rgba(0, 0, 0, 0.45)",
  );

  if (pathname.startsWith("/dashboard")) {
    return null;
  }

  return (
    <Box
      position="fixed"
      insetInlineEnd={{ base: 4, md: 6 }}
      bottom={{ base: 4, md: 6 }}
      zIndex={1200}
    >
      <AnimatePresence>
        {isOpen ? (
          <MotionBox
            initial={{ opacity: 0, y: 24, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.96 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            mb={4}
            w={{ base: "calc(100vw - 32px)", sm: "380px", md: "410px" }}
            h={{ base: "min(70vh, 620px)", md: "620px" }}
            bg={panelBg}
            borderRadius="24px"
            overflow="hidden"
            border="1px solid"
            borderColor={panelBorder}
            boxShadow={shadowColor}
            position="relative"
          >
            <IconButton
              aria-label="بستن چت"
              icon={<Icon as={FiX as any} />}
              position="absolute"
              top={5}
              left={5}
              zIndex={2}
              size="sm"
              borderRadius="full"
              bg="blackAlpha.600"
              color="white"
              onClick={() => setIsOpen(false)}
              _hover={{ bg: "blackAlpha.700" }}
              _active={{ bg: "blackAlpha.800" }}
            />

            <Box h="100%" bg={panelBg}>
              <iframe
                src={CHATBOT_URL}
                title="OmidIB Chatbot"
                style={{ width: "100%", height: "100%", border: "0" }}
                allow="clipboard-write; microphone"
              />
            </Box>
          </MotionBox>
        ) : null}
      </AnimatePresence>

      <MotionIconButton
        aria-label={isOpen ? "باز و بسته کردن چت‌بات" : "باز کردن چت‌بات"}
        icon={
          <Image
            src="/images/omidyar_avatar.png"
            alt=""
            w="100%"
            h="100%"
            objectFit="cover"
            objectPosition="top center"
          />
        }
        onClick={() => setIsOpen((current) => !current)}
        animate={
          isOpen
            ? { opacity: 1, scale: 1 }
            : { opacity: [1, 0.68, 1], scale: [1, 1.018, 1] }
        }
        transition={
          isOpen
            ? { duration: 0.2 }
            : {
                duration: 3.2,
                repeat: Infinity,
                ease: "easeInOut",
                times: [0, 0.18, 0.34],
              }
        }
        w={{ base: "58px", md: "64px" }}
        h={{ base: "58px", md: "64px" }}
        minW={0}
        p={0}
        overflow="hidden"
        borderRadius="full"
        bg={buttonBg}
        color="white"
        boxShadow="0 20px 45px rgba(173, 11, 6, 0.28)"
        _hover={{
          bg: buttonHoverBg,
          transform: "translateY(-2px)",
        }}
        _active={{
          bg: buttonBg,
          transform: "translateY(0)",
        }}
      />
    </Box>
  );
};
